export const getAmplifyConfig = (): unknown => {
  const config = {
    Auth: {
      region: process.env.AWS_REGION,
      identityPoolRegion: process.env.AWS_REGION,
      userPoolId: process.env.NEXT_PUBLIC_USER_POOL_ID,
      userPoolWebClientId: process.env.NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID,

      // OPTIONAL - Configuration for cookie storage
      // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
      // TODO: Decomment after migration is finished
      // cookieStorage: {
      //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      //   domain: '.localhost',
      //   // OPTIONAL - Cookie path
      //   path: '/',
      //   // OPTIONAL - Cookie expiration in days
      //   expires: 365,
      //   // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
      //   // sameSite: 'strict' | 'lax',
      //   // OPTIONAL - Cookie secure flag
      //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      //   secure: false,
      // },
      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      authenticationFlowType: 'USER_PASSWORD_AUTH', // TODO: After Migration Change to USER_SRP_AUTH

      oauth: {
        domain: process.env.NEXT_PUBLIC_DOMAIN,
        scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: process.env.NEXT_PUBLIC_WEBSITE_URL + '/login/confirm',
        redirectSignOut: process.env.NEXT_PUBLIC_WEBSITE_URL,
        responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      },
    },
    // Enable server side rendering
    ssr: true,
  }

  return config
}
